import {DocumentNode, gql} from "@apollo/client";

export const SAVE_PAYMENT_SIMPLE_ANALYTIC_MUTATION: DocumentNode = gql(`
    mutation SavePaymentSimpleAnalytic($dto: PaymentSimpleAnalyticRequest!) {
        savePaymentSimpleAnalytic(paymentSimpleAnalyticDto: $dto) {
            url
        }
    }
`);
